module.exports = require("./teo");